import React from "react";
import { Link } from "react-router-dom";
import { tees } from "./helpers";

const Tees = ({ match }) => {
  const teeOptions = tees().map((item, index) => {
    let liClass = "subpage-tab";
    let liStyle = {};
    if (match.params && match.params.tee === item) {
      liClass += " selected";
      liStyle.color = "#fff";
    }

    let show = "Show All";
    if (item === "1") {
      show = "Show Tee No. 1";
    } else if (item === "10") {
      show = "Show Tee No. 10";
    }

    let rnd = "";
    if (match.params && match.params.rnd) {
      rnd = match.params.rnd;
    }

    return (
      <li key={index} className={liClass}>
        <Link
          to={{
            pathname: `/${rnd}/${item}`,
          }}
          style={liStyle}
        >
          {show}
        </Link>
      </li>
    );
  });

  return <ul>{teeOptions}</ul>;
};

export default Tees;



// WEBPACK FOOTER //
// ./src/Tees.js